import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaBalanceScale, FaGavel, FaFileContract, FaLock, FaShieldAlt } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ConditionsUtilisation = () => {
    useEffect(() => {
        AOS.init({ duration: 1000, mirror: true, once: false });

        // Scroll to top on component mount
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header />
            <div className="conditions-page">
                {/* Hero Section */}
                <section className="hero-section py-5">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12 text-center" data-aos="fade-up">
                                <h1 className="fw-bold mb-4">
                                    Conditions Générales <span className="gradient-text">d'Utilisation</span>
                                </h1>
                                <p className="lead mb-0">
                                    Merci de lire attentivement les présentes conditions d'utilisation de nos services d'expertise comptable.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Main Content */}
                <section className="conditions-content py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card shadow-sm mb-5" data-aos="fade-up">
                                    <div className="card-body p-4 p-md-5">
                                        <div className="intro-section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">1. Présentation de Cinef-Expertise</h2>
                                            <p data-aos="fade-up">
                                                Cinef-Expertise est un cabinet d'expertise comptable proposant des services de comptabilité,
                                                audit, conseil fiscal et financier aux entreprises et aux particuliers. Notre site web
                                                a pour objet de présenter nos services et de faciliter la communication avec nos clients
                                                et partenaires.
                                            </p>
                                            <p data-aos="fade-up">
                                                Les présentes conditions générales d'utilisation définissent les modalités d'accès et
                                                d'utilisation de notre site internet. En naviguant sur notre site, vous acceptez sans réserve
                                                ces conditions d'utilisation.
                                            </p>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">2. Définitions</h2>
                                            <ul className="list-unstyled" data-aos="fade-up">
                                                <li className="mb-3">
                                                    <strong>Site :</strong> Le site web accessible à l'adresse www.cinef-expertise.com
                                                </li>
                                                <li className="mb-3">
                                                    <strong>Client :</strong> Toute personne physique ou morale qui utilise le site ou ses services
                                                </li>
                                                <li className="mb-3">
                                                    <strong>Utilisateur :</strong> Toute personne qui accède et navigue sur le site
                                                </li>
                                                <li className="mb-3">
                                                    <strong>Services :</strong> L'ensemble des prestations d'expertise comptable proposées par Cinef-Expertise
                                                </li>
                                                <li className="mb-3">
                                                    <strong>Contenu :</strong> Tous les éléments constituant l'information présente sur le site
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">3. Accès au site</h2>
                                            <p data-aos="fade-up">
                                                L'accès au site est ouvert à tout utilisateur disposant d'une connexion Internet.
                                                Tous les coûts afférents à l'accès au site, que ce soient les frais matériels, logiciels
                                                ou de connexion à Internet sont exclusivement à la charge de l'utilisateur.
                                            </p>
                                            <p data-aos="fade-up">
                                                Cinef-Expertise ne peut être tenu responsable des éventuelles interruptions, pannes ou
                                                dysfonctionnements du site, quelle qu'en soit la cause.
                                            </p>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">4. Propriété intellectuelle</h2>
                                            <p data-aos="fade-up">
                                                L'ensemble des éléments constituant le site (textes, graphismes, logiciels, photographies,
                                                images, vidéos, sons, logos, marques, etc.) est la propriété exclusive de Cinef-Expertise
                                                ou fait l'objet d'une autorisation d'utilisation. Ces éléments sont protégés par les lois
                                                relatives à la propriété intellectuelle.
                                            </p>
                                            <p data-aos="fade-up">
                                                Toute reproduction, représentation, modification, publication, adaptation ou exploitation
                                                de tout ou partie des éléments du site est strictement interdite sans l'autorisation écrite
                                                préalable de Cinef-Expertise.
                                            </p>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">5. Protection des données personnelles</h2>
                                            <p data-aos="fade-up">
                                                Conformément à la législation en vigueur, notamment le Règlement Général sur la Protection
                                                des Données (RGPD), Cinef-Expertise s'engage à respecter la confidentialité des informations
                                                personnelles communiquées par les utilisateurs du site.
                                            </p>
                                            <p data-aos="fade-up">
                                                Les données personnelles collectées sur le site sont destinées exclusivement à Cinef-Expertise
                                                et sont utilisées pour le traitement des demandes de contact, l'envoi d'informations
                                                commerciales ou la gestion de la relation client.
                                            </p>
                                            <p data-aos="fade-up">
                                                Conformément à la réglementation, vous disposez d'un droit d'accès, de rectification,
                                                de suppression et d'opposition concernant vos données personnelles. Pour exercer ces droits,
                                                vous pouvez nous contacter à l'adresse suivante : privacy@cinef-expertise.com.
                                            </p>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">6. Responsabilité</h2>
                                            <p data-aos="fade-up">
                                                Les informations diffusées sur le site sont fournies à titre informatif. Malgré tout le soin
                                                apporté à leur exactitude, Cinef-Expertise ne peut garantir l'absence d'erreurs ou d'omissions.
                                            </p>
                                            <p data-aos="fade-up">
                                                Cinef-Expertise décline toute responsabilité concernant :
                                            </p>
                                            <ul data-aos="fade-up">
                                                <li>Les interruptions du site pour des opérations de maintenance</li>
                                                <li>Les dommages résultant de l'intrusion frauduleuse d'un tiers sur le site</li>
                                                <li>Les dommages indirects résultant de l'utilisation du site</li>
                                                <li>L'impossibilité d'accéder temporairement au site en raison de problèmes techniques</li>
                                            </ul>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">7. Cookies</h2>
                                            <p data-aos="fade-up">
                                                Le site de Cinef-Expertise utilise des cookies pour améliorer l'expérience de navigation
                                                des utilisateurs. Un cookie est un petit fichier texte déposé sur votre ordinateur lors
                                                de la visite d'un site. Ils permettent notamment de mémoriser vos préférences de navigation.
                                            </p>
                                            <p data-aos="fade-up">
                                                Vous pouvez à tout moment désactiver les cookies en modifiant les paramètres de votre
                                                navigateur. Cependant, cette désactivation pourrait empêcher l'utilisation de certaines
                                                fonctionnalités du site.
                                            </p>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">8. Liens hypertextes</h2>
                                            <p data-aos="fade-up">
                                                Le site peut contenir des liens hypertextes vers d'autres sites Internet. Cinef-Expertise
                                                n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
                                            </p>
                                        </div>

                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">9. Modification des conditions d'utilisation</h2>
                                            <p data-aos="fade-up">
                                                Cinef-Expertise se réserve le droit de modifier à tout moment les présentes conditions
                                                d'utilisation. Les utilisateurs sont donc invités à les consulter régulièrement.
                                            </p>
                                        </div>

                                        <div className="section">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">10. Droit applicable et juridiction compétente</h2>
                                            <p data-aos="fade-up">
                                                Les présentes conditions d'utilisation sont régies par la loi française. En cas de litige,
                                                les tribunaux français seront seuls compétents.
                                            </p>
                                            <p data-aos="fade-up">
                                                Pour toute question relative aux présentes conditions d'utilisation, vous pouvez nous
                                                contacter à l'adresse suivante : contact@cinef-expertise.com
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Legal Icons */}
                                <div className="row legal-icons mb-5">
                                    <div className="col-md-4 text-center mb-4" data-aos="fade-up">
                                        <FaBalanceScale className="legal-icon mb-3" />
                                        <h5 className="fw-bold">Conformité Légale</h5>
                                        <p>Nos conditions respectent toutes les obligations légales en vigueur.</p>
                                    </div>
                                    <div className="col-md-4 text-center mb-4" data-aos="fade-up" data-aos-delay="100">
                                        <FaShieldAlt className="legal-icon mb-3" />
                                        <h5 className="fw-bold">Protection des Données</h5>
                                        <p>Vos informations personnelles sont protégées selon les normes RGPD.</p>
                                    </div>
                                    <div className="col-md-4 text-center mb-4" data-aos="fade-up" data-aos-delay="200">
                                        <FaFileContract className="legal-icon mb-3" />
                                        <h5 className="fw-bold">Engagement Contractuel</h5>
                                        <p>Nos conditions constituent un engagement contractuel clair et transparent.</p>
                                    </div>
                                </div>

                                {/* Contact Section */}
                                <div className="contact-box text-center p-4 rounded" data-aos="zoom-in">
                                    <h3 className="fw-bold mb-3">Une question sur nos conditions ?</h3>
                                    <p className="mb-4">Notre équipe juridique est à votre disposition pour répondre à toutes vos questions.</p>
                                    <a href="/contact" className="cta-button">Contactez-nous ↗</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <style>{`
                .hero-section {
                    background: linear-gradient(rgba(42, 119, 255, 0.05), rgba(230, 57, 70, 0.05));
                    padding: 80px 0;
                }

                .gradient-text {
                    background: linear-gradient(to right, #008a44, #dc3545);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .conditions-content {
                    background-color: #f8f9fa;
                }

                .card {
                    border: none;
                    border-radius: 15px;
                }

                h2 {
                    color: #008a44;
                    border-left: 4px solid #e63946;
                    padding-left: 15px;
                }

                .legal-icon {
                    font-size: 50px;
                    color: #e63946;
                }

                .contact-box {
                 background: linear-gradient(45deg, #008a44, #e63946);
                  color: white;
                 width: 60%;              /* Réduit la largeur à 60% du parent */
                 margin: 0 auto;          /* Centre horizontalement */
                 padding: 20px;           /* Optionnel : ajoute un peu d'espace intérieur */
                 border-radius: 8px;      /* Optionnel : arrondit les bords */
                }


                .cta-button {
                    background-color: white;
                    color: #2a77ff;
                    padding: 12px 24px;
                    border-radius: 50px;
                    font-weight: bold;
                    text-decoration: none;
                    display: inline-block;
                    transition: transform 0.3s ease-in-out;
                }

                .cta-button:hover {
                    transform: scale(1.1);
                    background-color: #f8f9fa;
                }

                ul li {
                    margin-bottom: 10px;
                }

                @media (max-width: 768px) {
                    .hero-section {
                        padding: 50px 0;
                    }
                    
                    h1 {
                        font-size: 2rem;
                    }
                    
                    h2 {
                        font-size: 1.5rem;
                    }
                }
            `}</style>
            </div>
            <Footer />
        </>
    );
};

export default ConditionsUtilisation;